module.exports = __webpack_public_path__ + "img/new-previous-btn-w.e89444a3.svg";